/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SchoolGroupDto } from '../models/SchoolGroupDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SchoolGroupControllerService {
  /**
   * createSchoolGroup
   * @returns any OK
   * @throws ApiError
   */
  public static createSchoolGroupUsingPost({
    logo,
    schoolGroup,
  }: {
    /**
     * logo
     */
    logo: Blob;
    /**
     * school-group
     */
    schoolGroup: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/emis/school-group',
      query: {
        'school-group': schoolGroup,
      },
      body: logo,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateSchoolGroup
   * @returns any OK
   * @throws ApiError
   */
  public static updateSchoolGroupUsingPut({
    schoolGroupDto,
  }: {
    /**
     * schoolGroupDto
     */
    schoolGroupDto: SchoolGroupDto;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/emis/school-group',
      body: schoolGroupDto,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSchoolGroup
   * @returns any OK
   * @throws ApiError
   */
  public static getSchoolGroupUsingGet({
    schoolGroupId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}',
      path: {
        schoolGroupId: schoolGroupId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getFilterParameters
   * @returns any OK
   * @throws ApiError
   */
  public static getFilterParametersUsingGet({
    schoolGroupId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/filter-parameters',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getFinancialAnalysisProjection
   * @returns any OK
   * @throws ApiError
   */
  public static getFinancialAnalysisProjectionUsingGet({
    schoolGroupId,
    classLevelName,
    schoolId,
    sectionId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * classLevelName
     */
    classLevelName?: string;
    /**
     * schoolId
     */
    schoolId?: string;
    /**
     * sectionId
     */
    sectionId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/financial-analysis',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        classLevelName: classLevelName,
        schoolId: schoolId,
        sectionId: sectionId,
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSchoolGroupStatistics
   * @returns any OK
   * @throws ApiError
   */
  public static getSchoolGroupStatisticsUsingGet({
    schoolGroupId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * sessionId
     */
    sessionId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/group-statistics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getMonthlyFinancialAnalysis
   * @returns any OK
   * @throws ApiError
   */
  public static getMonthlyFinancialAnalysisUsingGet({
    schoolGroupId,
    classLevelName,
    sectionId,
    sessionId,
    tenantId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * classLevelName
     */
    classLevelName?: string;
    /**
     * sectionId
     */
    sectionId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
    /**
     * tenantId
     */
    tenantId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/monthly-financial-analysis',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        classLevelName: classLevelName,
        sectionId: sectionId,
        sessionId: sessionId,
        tenantId: tenantId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffAgeGeneralAnalytics
   * @returns any OK
   * @throws ApiError
   */
  public static getStaffAgeGeneralAnalyticsUsingGet({
    schoolGroupId,
    schoolId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * schoolId
     */
    schoolId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/staff-age-analytics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        schoolId: schoolId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffCount
   * @returns any OK
   * @throws ApiError
   */
  public static getStaffCountUsingGet({
    schoolGroupId,
    schoolId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * schoolId
     */
    schoolId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/staff-count',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        schoolId: schoolId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffGenderAnalytics
   * @returns any OK
   * @throws ApiError
   */
  public static getStaffGenderAnalyticsUsingGet({
    schoolGroupId,
    schoolId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * schoolId
     */
    schoolId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/staff-gender-analytics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        schoolId: schoolId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStudentAgeGeneralAnalytics
   * @returns any OK
   * @throws ApiError
   */
  public static getStudentAgeGeneralAnalyticsUsingGet({
    schoolGroupId,
    classLevelName,
    schoolId,
    sectionId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * classLevelName
     */
    classLevelName?: string;
    /**
     * schoolId
     */
    schoolId?: string;
    /**
     * sectionId
     */
    sectionId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/student-age-analytics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        classLevelName: classLevelName,
        schoolId: schoolId,
        sectionId: sectionId,
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStudentCount
   * @returns any OK
   * @throws ApiError
   */
  public static getStudentCountUsingGet({
    schoolGroupId,
    classLevelName,
    schoolId,
    sectionId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * classLevelName
     */
    classLevelName?: string;
    /**
     * schoolId
     */
    schoolId?: string;
    /**
     * sectionId
     */
    sectionId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/student-count',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        classLevelName: classLevelName,
        schoolId: schoolId,
        sectionId: sectionId,
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStudentGenderGeneralAnalytics
   * @returns any OK
   * @throws ApiError
   */
  public static getStudentGenderGeneralAnalyticsUsingGet({
    schoolGroupId,
    classLevelName,
    schoolId,
    sectionId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * classLevelName
     */
    classLevelName?: string;
    /**
     * schoolId
     */
    schoolId?: string;
    /**
     * sectionId
     */
    sectionId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/student-gender-analytics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        classLevelName: classLevelName,
        schoolId: schoolId,
        sectionId: sectionId,
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSubjectDistributionAnalytics
   * @returns any OK
   * @throws ApiError
   */
  public static getSubjectDistributionAnalyticsUsingGet({
    schoolGroupId,
    schoolId,
    sessionId,
  }: {
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
    /**
     * schoolId
     */
    schoolId?: string;
    /**
     * sessionId
     */
    sessionId?: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/emis/school-group/{schoolGroupId}/subject-distribution-analytics',
      path: {
        schoolGroupId: schoolGroupId,
      },
      query: {
        schoolId: schoolId,
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * uploadLogo
   * @returns string OK
   * @returns any Created
   * @throws ApiError
   */
  public static uploadLogoUsingPost({
    logo,
    schoolGroupId,
  }: {
    /**
     * logo
     */
    logo: Blob;
    /**
     * schoolGroupId
     */
    schoolGroupId: string;
  }): CancelablePromise<string | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/emis/school-group/{schoolGroupId}/uploads/logo',
      path: {
        schoolGroupId: schoolGroupId,
      },
      body: logo,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
